import React from "react";
import { useLoading, useRootAppStore } from "@hooks";
import { observer } from "mobx-react";
import { Button } from "@components/buttons";
import { MobilePlatform } from "@state/stores/types";
import { useTranslation } from "react-i18next";

export default observer(function BankIdPendingLoader(props: {
	isLoading?: boolean;
}) {
	const { isLoading } = useLoading();

	const { t } = useTranslation("login");

	const { bankIdCapacitorStore } = useRootAppStore<MobilePlatform>();

	if (!isLoading && !props?.isLoading) {
		return null;
	}

	if (!WEBPACK_IS_BANKID_ENABLED) {
		return null;
	}

	return (
		<div className="loader loader--full">
			<div className="loader__spinner loader__card">
				<div className="loader__spinner__wrapper">
					<div />
					<div />
					<div />
				</div>
				<div className="loader__title u-color--text--primary">
					{t("BANK_ID.AUTH_PENDING")}
				</div>
				<Button
					type="button"
					className="btn--base btn--block btn--primary--inverted u-mar--top--xsml"
					btnText={t("COMMON.CANCEL")}
					onClick={() => bankIdCapacitorStore.cancelAuth()}
				/>
			</div>
		</div>
	);
});
